import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import * as turf from '@turf/helpers';
import union from '@turf/union';

/**
 * 专门处理 Tile 数据相关
 */
export class TileSourceService {
  getCombineFeature(features) {
    let p = null;
    const properties = features[0];
    features.map(feature => {
      const polygon = turf.polygon(feature.coordinates);
      // tslint:disable-next-line: prefer-conditional-expression
      if (p === null) {
        p = polygon;
      } else {
        p = union(p, polygon);
      }
    });
    if (properties) {
      p.properties = _objectSpread({}, properties);
    }
    return p;
  }
}